export enum Portal {
    CPP = 'cpp',
    SPP = 'spp',
    TEST_GEN = 'test_gen',
}

export function detectPortal(): Portal {
    const host = window.location.hostname;
    const url = window.location.href;
    if (host.startsWith('supplier.') || url.includes('spp')) {
        return Portal.SPP;
    } else if (url.includes('admin_dash')) {
        return Portal.TEST_GEN;
    }
    return Portal.CPP;
}
